import { useEffect, useState } from 'react';
import { Badge, Select, Space } from 'antd';
import { observer } from 'mobx-react-lite';

import { DataGrid } from 'app/common/ui/data-grid';
import { useSelectedRows } from 'app/common/ui/data-grid/hooks';

import { TTrip } from '../../../core/trips';
import { manageTripsCols } from './manage-trips-cols';

type ManageTripsGridProps = {
  rows: TTrip[];
  onChange?: (trips: TTrip[]) => void;
};
export const ManageTripsGrid = observer((props: ManageTripsGridProps) => {
  const [editedRows, setEditedRows] = useState(props.rows);
  const { selectedRows, selectRows } = useSelectedRows<TTrip>();

  const hasSelectedRows = selectedRows.length > 0;

  const handleStatusChange = (status: boolean) => {
    const selectedRowsIds = Object.fromEntries(
      selectedRows.map((row) => [row.id, row])
    );

    setEditedRows((editedRows) => {
      const result = editedRows.map((row) =>
        selectedRowsIds[row.id] ? { ...row, blocked: status } : row
      );

      return result;
    });

    // after changing edited rows, selected rows are reset
    // we need to restore them
    const prevSelectedRows = Object.values(selectedRowsIds);

    selectRows(prevSelectedRows);
  };

  useEffect(() => {
    if (props.rows === editedRows) return;

    props?.onChange && props?.onChange(editedRows);
  }, [editedRows, props]);

  return (
    <>
      <div style={{ display: 'flex', marginBottom: 16 }}>
        <Space>
          <Select
            placeholder="Выберите статус"
            value={null}
            disabled={!hasSelectedRows}
            onChange={handleStatusChange}
          >
            <Select.Option value={false}>
              <Badge status="success" text="Активен" />
            </Select.Option>
            <Select.Option value={true}>
              <Badge status="error" text="Заблокирован" />
            </Select.Option>
          </Select>
        </Space>
      </div>

      <DataGrid
        rowData={editedRows}
        columnDefs={manageTripsCols}
        autoSizeStrategy={{ type: 'fitCellContents' }}
        rowSelection="multiple"
        persistSettingsId="TripEntityGrid/ManageTrips"
        getRowId={(row: any) => row.data.id}
      />
    </>
  );
});
